import React from "react";
import { ProductItem } from "../types/bomTypes";
import { roundValue } from "../../../../../grocery/hooks/useRound";
import CommonTable, { HeadCell } from "../../../../../grocery/components/CommonTable";

interface Props {
  items: ProductItem[];
}
interface ProductRow {
  id: number;
  sno: number;
  productName: JSX.Element;
  quantity: string | number;
  totalPrice: string | number;
}

const ProductTable: React.FC<Props> = ({ items }) => {
  const data: ProductRow[] = items.map((p, index) => ({
    id: index + 1,
    sno: index + 1,
    productName: (
      <div className='flex flex-col'>
        <span className='text-sm font-medium text-gray-900'>{p.productName}</span>
        {p.arabicword && <span className='text-xs text-gray-500 mt-0.5'>{p.arabicword}</span>}
      </div>
    ),
    quantity: p.quantity,
    totalPrice: roundValue(p.totalPrice),
  }));

  const headCells: HeadCell<ProductRow>[] = [
    { id: "sno", label: "S.No" },
    { id: "productName", label: "Product name" },
    // { id: "arabicword", label: "Arabic word" },
    { id: "quantity", label: "QTY", numeric: true },
    { id: "totalPrice", label: "Amount (QAR)", numeric: true },
  ];

  return (
    <CommonTable
      title='Products'
      showToolbar={false}
      data={data}
      headCells={headCells}
      selectable={false}
      denseToggle={true}
      pagenation={true}
      className='w-full min-w-[530px] h-[350px]'
    />
  );
};

export default ProductTable;
